module.exports = __webpack_public_path__ + "static/media/down-caret-blue.b211eff2.svg";